// extracted by mini-css-extract-plugin
module.exports = {"link":"SignInPage_link__3Vxza","formRow":"SignInPage_formRow__1R62Y"};